// extracted by mini-css-extract-plugin
export default {"wrap":"cJ-z","subtitle":"dJ-z","contentWrap":"eJ-z","imgWrap":"fJ-z","heading":"gJ-z","copy":"hJ-z"};